import React from "react";
import styles from "./PageWrapper.module.scss";

const PageWrapper = ({ children, className = "", style }) => {
  const wrapperClassName = [styles.pageWrapper, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClassName} style={style}>
      {children}
    </div>
  );
};

export default PageWrapper;




